// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4aa5f672","239":"da8bace7","455":"fa087933","826":"2f2c9712"}[chunkId] + ".chunk.js";
};